import { z } from "zod";

export enum CommunityContractPackageTier {
  basic = "basic",
  diocesan = "diocesan",
  expansion = "expansion",
  mobilization = "mobilization",
  growth = "growth",
  hdp = "hdp",
  seasonal = "seasonal",
  starter = "starter",
}

export const communityContractPackageTierEnum = z.enum(
  CommunityContractPackageTier,
);
